<template>
  <div class="recruit-manage">
    <homeHeader title="招聘岗位" />
    
    <div class="homeRightContent">
      <el-tabs class="recruitTab" v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="岗位管理" name="job">
          <JobManage />
        </el-tab-pane>
        <el-tab-pane label="公司管理" name="company">
          <CompanyManage />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import CompanyManage from "./CompanyManage.vue";
import JobManage from "./JobManage.vue";
import homeHeader from "@/components/homeHeader.vue";

export default {
  name: "RecruitManage",
  components: {
    homeHeader,
    CompanyManage,
    JobManage,
  },
  data() {
    return {
      activeTab: "job",
    };
  },
  methods: {
    handleTabClick(tab) {
      // 预留Tab切换逻辑
      console.log("Tab切换", tab.name);
    },
  },
};
</script>

<style lang="less">
.recruitTab {
  height: 100%;
  display: flex;
  flex-direction: column;
  .el-tabs__content {
    flex: 1;
    .el-tab-pane {
      height: 100%;
      > div {
        height: 100%;
        display: flex;
        flex-direction: column;
      }
    }
  }
}
</style>
